<template>
    <div class="rooms">
        <div class="page-header">
            <h1>
                Products

                <small>
                    <button class="btn btn-default btn-fill btn-sm">
                        <span class="fa fa-plus fa-fw"></span>
                        Add new
                    </button>
                </small>
            </h1>
        </div>

        <loader v-if="!hasLoaded"></loader>

        <ul class="list-group" v-else>
            <router-link :to="{name: 'products.view', params: {id: product.id}}" class="list-group-item navigatable" v-for="product in products" :key="product.id">
                <span class="pe-7s-angle-right-circle pull-right action"></span>

                {{product.name}}<br />
                <small>{{product.price}},- DKK</small>
            </router-link>
        </ul>
    </div>
</template>

<style lang="scss" scoped>
    .rooms {
        .list-group {
            .list-group-item {
                color: #000;
                padding: 20px 25px;

                small {
                    color: lighten(#000, 25%);
                }

                .action {
                    color: #828282;
                    font-size: 25px;
                    margin-top: 8px;
                }

                &:hover,
                &.navigation-selected-active {
                    color: #555;
                    text-decoration: none;
                    background-color: #f5f5f5;

                    .action {
                        color: #ff3d70;
                    }
                }
            }
        }
    }
</style>
<script>
    import Loader from '@/components/layout/Loader'

    const ProductService = require('@/services/products/ProductService')

    export default {
        data() {
            return {
                products: [],
                hasLoaded: false
            }
        },

        mounted() {
            this.load()
        },

        methods: {
            load() {
                ProductService.findAll({
                    sort: [{
                        key: 'name',
                        direction: 'ASC'
                    }]
                }, (response) => {
                    const data = response.data

                    this.products = data.rows
                    this.hasLoaded = true
                })
            }
        },

        components: {
            Loader
        }
    }
</script>


// WEBPACK FOOTER //
// Products.vue?2be942b7